// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I5vy","label":"styles_label__9ARaQ"};